export default "__VITE_ASSET__Bo$jd8TR__"